module.exports = __webpack_public_path__ + "img/cash_nl200.e7158152.png";